import styled, { css } from 'styled-components';
import { animated } from 'react-spring';
import { NoSelect, noSelect } from '../../../../styles/mixins';

const divideControlsInSubsections = css`
  .container-controls {
    background: transparent;
    padding: 0;
    > .oss-ui-checkbox,
    > .multilistbox,
    > .oss-ui-slider {
      background: white;
      padding-left: 16px !important;
      padding-right: 16px !important;
      border-radius: 8px;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const ContainerItem = styled.div`
  position: relative;
  width: 100%;
  margin-top: 24px;
  overflow: visible;

  &:first-child {
    margin-top: 0;
  }

  &.divide-controls-in-subsections {
    ${divideControlsInSubsections};
  }

  .section-ranking-box {
    width: 100%;
    background: #f3f3f3;
    padding: 0 !important;
  }

  .overflow-visible {
    overflow: visible;
  }

  .container-controls {
    position: relative;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 16px;
    border-radius: 8px;

    :has(> .multilistbox),
    :has(> .radio),
    :has(> .oss-ui-checkbox) {
      padding: 8px 16px;
    }

    &.full-screen {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 99;
      flex-direction: column;
      height: 100vh !important;
      border-radius: 0;
      padding: 0;
      & > div {
        background-color: #fff;
        padding: 0 16px;
      }
    }
  }
`;

const StyledDiv = styled.div``;
const AnimatedDiv = animated(StyledDiv);

export const AnimatedContainer = styled(AnimatedDiv)<{ $isExpanded: boolean }>`
  position: relative;
  border-radius: 8px;
  will-change: height;
  ${({ $isExpanded }) => ($isExpanded ? 'overflow: hidden' : 'overflow: hidden !important')}
`;

export const ScrollContainer = styled.div`
  overflow-x: auto;
  scrollbar-width: none;
  width: 100%;
  max-width: 100%;
  scroll-snap-type: x mandatory;
  border-radius: 8px;

  .oss-ui-checkbox {
    margin-bottom: 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ToggleButton = styled.div<{ isExpanded: boolean }>`
  ${({ isExpanded }) => (isExpanded ? 'transform: rotate(180deg);' : 'transform: rotate(0);')}
  transition: transform 0.2s;
  transition-duration: 0.2s, 0.2s;
  transition-timing-function: ease-in, ease-out;
  transform-origin: center;
  display: flex;
  align-items: center;
  height: 16px;

  &:focus-visible {
    border-radius: 2px;
  }

  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
`;

export const ContainerLabel = styled.h3`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  span {
    ${NoSelect}
  }
`;

export const Label = styled.button`
  background: none;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  width: 100%;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  font-size: ${({ theme }) => theme.kallisto.font.size['225']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['350']};

  &.container-collapsible {
    cursor: pointer;
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  background: none;
  border: none;
  right: 25px;
  padding-bottom: 16px;
  cursor: pointer;
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.regular};
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  ${noSelect}
`;
